import { render, staticRenderFns } from "./CostPricesAdditionalServicesProviderSelection.vue?vue&type=template&id=1ab878e9"
import script from "./CostPricesAdditionalServicesProviderSelection.vue?vue&type=script&lang=js"
export * from "./CostPricesAdditionalServicesProviderSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports